import {Component} from '@angular/core';
import {IFilterAngularComp} from 'ag-grid-angular';
import {AgPromise, IDoesFilterPassParams, IFilterParams} from 'ag-grid-community';
import {ValidFilterOption} from './valid-filter-option';

@Component({
  selector: 'mydocma-mm-valid-filter',
  templateUrl: './valid-filter.component.html',
  styleUrls: ['./valid-filter.component.scss']
})
export class ValidFilterComponent implements IFilterAngularComp {

  public selectableOptions: ValidFilterOption[];
  public allOptionsSelected = false;
  public showAllOption = false;

  private filterParams: IFilterParams;
  private columnField: string;
  private comparator;
  private filterValueGetter;

  constructor() {
  }

  agInit(params: any): void {
    this.filterParams = params;

    this.filterValueGetter = params.filterValueGetter;
    this.comparator = params.comparator;
    this.selectableOptions = params.selectableOptions;
    this.columnField = params.colDef.field;
    this.showAllOption = params.showAllOption
    this.toggleAll();
  }

  isFilterActive(): boolean {
    const selectedCount = this.getSelectedCount();
    return selectedCount !== 0 && selectedCount !== this.selectableOptions.length;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (this.comparator) {
      return this.comparator(params);
    }

    let columnData;
    if(this.filterValueGetter) {
      columnData = this.filterValueGetter(params.data);
    } else {
      columnData = params.data[this.columnField];
    }

    return !!this.selectableOptions
      .filter(p => p.selected)
      .find( p =>  p.id === columnData);
  }

  getModel() {
    const selectedCount = this.getSelectedCount();
    if (selectedCount === 0 || selectedCount === this.selectableOptions.length) {
      return null;
    }
    return this.selectableOptions.filter(p => p.selected);
  }

  setModel(model: any): void | AgPromise<void> {
    if (model) {
      this.selectableOptions.forEach(option => {
        const filter = model.find(m => m.id === option.id);
        option.selected = filter ? filter.selected : false;
      });
    }
    if (!model) {
      this.selectableOptions.forEach(p => p.selected = true);
      this.allOptionsSelected = true;
    }
  }

  toggleAll(): void {
    this.allOptionsSelected = !this.allOptionsSelected;
    this.selectableOptions.forEach(p => p.selected = this.allOptionsSelected);
    this.filterParams.filterChangedCallback();
  }

  toggleOption(operation: ValidFilterOption): void {
    operation.selected = !operation.selected;
    const selectedCount = this.getSelectedCount();
    this.allOptionsSelected = selectedCount === this.selectableOptions.length ? true : false;
    this.filterParams.filterChangedCallback();
  }

  private getSelectedCount(): number {
    return this.selectableOptions.filter(option => option.selected).length;
  }
}
